import React from 'react';
import { Button, Dropdown, MenuProps, Space } from 'antd';
import styles from './style.module.scss';

const PullDown: React.FC<{
  title?: string;
  menuProps?: MenuProps;
}> = ({ title, menuProps }) => (
  <Dropdown menu={menuProps} overlayClassName={styles.wrapper} trigger={['click']}>
    <Button className={styles.mainButton}>
      <Space>{title}</Space>
    </Button>
  </Dropdown>
);

export default PullDown;
